var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2812 7.77538L6.52812 3.21011C6.23645 2.92997 5.76355 2.92997 5.47188 3.21011L0.718757 7.77539C0.427082 8.05553 0.427082 8.50974 0.718758 8.78989C1.01043 9.07004 1.48333 9.07004 1.77501 8.78989L6 4.73187L10.225 8.78989C10.5167 9.07004 10.9896 9.07004 11.2812 8.78989C11.5729 8.50974 11.5729 8.05553 11.2812 7.77538Z",
    fill: "currentColor",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsUp);
export default __webpack_public_path__ + "static/media/arrows-up.8860a635f06cd80fd7748c6e294c14f0.svg";
export { ForwardRef as ReactComponent };